import { UserStateContext } from "@/contexts/UserStateProvider";
import { useRetrieveTiktokSellerAccountById } from "@/hooks/tiktokSellerAccount.hooks";
import {
  AlertTriangleIcon,
  ChevronDown,
  LogOut,
  PencilIcon,
  PlusCircle,
  StoreIcon,
  User,
} from "lucide-react";
import { useContext, useState } from "react";
import { Button } from "./ui/button";
import { useOrganisationPlan } from "@/hooks/organisation.hooks";
import moment from "moment";
import { useNavigate } from "react-router";
import { OrderCount } from "./order-count";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const SwitchSellerAccount = () => {
  const { selectedSellerAccountId, setSelectedSellerAccountId } =
    useContext(UserStateContext);
  const { data: sellerAccount, isLoading } = useRetrieveTiktokSellerAccountById(
    selectedSellerAccountId
  );
  const { data: organisationPlan } = useOrganisationPlan();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { logOut } = useContext(UserStateContext);

  return (
    <>
      {organisationPlan?.plan === "TRIAL" &&
        organisationPlan?.planTrialEndsAt && (
          <div className="mb-2 px-4">
            <div className="text-xs text-red-500 font-medium flex gap-1.5 items-center justify-center">
              <AlertTriangleIcon size={12} />
              <span>
                Trial ends on{" "}
                {moment.utc(organisationPlan.planTrialEndsAt).format("DD MMM YYYY")}
              </span>
            </div>
          </div>
        )}
      <div className="w-full px-4 flex flex-col gap-2">
        <DropdownMenu open={open} onOpenChange={setOpen}>
          <DropdownMenuTrigger asChild>
            <Button
              disabled={isLoading}
              variant="outline"
              className="w-full flex justify-between gap-2 items-center break-all whitespace-normal text-sm border-dashed bg-background/80 hover:bg-muted/50"
            >
              <div className="flex gap-2 items-center w-full overflow-hidden">
                <StoreIcon size={14} className="shrink-0 text-primary" />
                <span className="truncate font-medium max-w-[80%]">
                  {sellerAccount?.sellerName || "Select Account"}
                </span>
              </div>
              <ChevronDown size={14} className="text-muted-foreground" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>
              {sellerAccount?.sellerName || "Select Account"}
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => {
                setSelectedSellerAccountId(null);
                navigate("/portal");
                setOpen(false);
              }}
            >
              <StoreIcon className="mr-2 h-4 w-4" />
              <span>Manage Stores</span>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => {
                logOut();
                setOpen(false);
              }}
            >
              <LogOut className="mr-2 h-4 w-4" />
              <span>Logout</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <div className="mx-4 mt-2">
        <OrderCount compact />
      </div>
    </>
  );
};
